import axios from '../axios'

export const getAppointmentDetails = async (appointmentId, processId, pageLang, pageCountry) => {
  return await axios
    .get(
      `/appointment/details?appointment_id=${encodeURIComponent(appointmentId)}&process_id=${encodeURIComponent(
        processId
      )}&lang=${pageLang}&country=${pageCountry}`
    )
    .then(
      (response) => Promise.resolve(response),
      (error) => Promise.reject(error)
    )
}

export const rescheduleAppointment = async (appointmentDataObject) => {
  return await axios.post(`/reschedule-appointment`, appointmentDataObject).then(
    (response) => Promise.resolve(response),
    (error) => Promise.reject(error)
  )
}

export const cancelAppointment = async (appointmentId, processId) => {
  return await axios
    .post(
      `/cancel-appointment?appointment_id=${encodeURIComponent(appointmentId)}&process_id=${encodeURIComponent(
        processId
      )}`
    )
    .then(
      (response) => Promise.resolve(response),
      (error) => Promise.reject(error)
    )
}
